import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from "react-helmet-async";

const sList = [
    {
        name: "Customised Enclosure Solutions",
        subText: "We provide tailor-made enclosure systems designed to meet your specific requirements. Every solution ensures durability, functionality, and ease of integration for your applications.",
        sImg: "/assets/newsr6.png",
        sLink: "/customised-enclosure-solutions",
    },
    {
        name: "Cable Termination \nSupport & Services",
        subText: "Our factory-trained engineers offer expert guidance in cable preparation, terminal selection, and installation. We ensure full traceability and precision in every termination process.",
        sImg: "/assets/new ser.png",
        sLink: "/cable-termination",
    },
    {
        name: "Cable & Industrial Labelling",
        subText: "We deliver professional labelling solutions for cables and wires, helping you identify connections easily. Our labels enhance safety, accuracy, and speed in maintenance and upgrades.",
        sImg: "/assets/aps3.png",
        sLink: "/cable-industrial",
    },
    {
        name: " Cable Cutting, Harnessing, Labelling & Assemblies",
        subText: "Our pre-cutting and labelling services provide neatly cut cables with precise tags. This ensures faster installation, improved organization, and reduced human error on-site.",
        sImg: "/assets/newsr3.png",
        sLink: "/cable-cutting",
    },
    {
        name: "Transit - Inspection & Design",
        subText: "We perform detailed site inspections of cable and pipe penetrations across industries. Our design support ensures secure sealing, safety, and long-term reliability in every project.",
        sImg: "/assets/new ser2.png",
        sLink: "/transit-inspection",
    }

]

function Service() {
    return (
        <>
        <Helmet>
    <title>
        Cable Management & Electrical Services UAE | Al Ibtekar
    </title>

    <meta
        name="description"
        content="Explore Al Ibtekar's cable management and electrical services in the UAE, including customised enclosures, cable termination, industrial labelling, cable cutting, harnessing, assemblies and transit inspection."
    />

    <meta
        name="keywords"
        content="cable management services UAE, cable termination services UAE, customised enclosure solutions UAE, cable labelling UAE, industrial labelling UAE, cable cutting UAE, cable harnessing UAE, cable assemblies UAE, transit inspection UAE, electrical services UAE"
    />

    <link
        rel="canonical"
        href="https://saig.me/services"
    />

    <meta
        property="og:title"
        content="Cable Management & Electrical Services UAE | Al Ibtekar"
    />

    <meta
        property="og:description"
        content="Professional cable management, cable termination, enclosure, labelling, cable cutting, harnessing and inspection services for industrial applications across the UAE."
    />

    <meta
        property="og:url"
        content="https://saig.me/services"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:site_name"
        content="Al Ibtekar"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Cable Management & Electrical Services UAE | Al Ibtekar"
    />

    <meta
        name="twitter:description"
        content="Explore reliable cable management, termination, enclosure, labelling and industrial electrical services from Al Ibtekar in the UAE."
    />
</Helmet>
            <div className='newbanner-about newbanner-about2'>
                <div className="max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
                    <h6 className="font-[500] font-kanit lg:text-[60px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">Our Services</h6>
                    <p className="lg:max-w-[582px] max-w-[250px] w-full font-[300] font-inter lg:text-[20px] text-[12px] lg:leading-[30px] leading-[16px] text-[#FFFFFF]">Smart, Safe, and Field-Tested Solutions — All in One Place.
                    </p>
                </div>
            </div>
            {/* <div className="mt-[91px] overflow-hidden relative">
                <img src="/assets/service/bg2.png" className='w-full lg:h-auto h-[300px] object-cover' alt="	Trusted cable management and termination solutions provider in the UAE" />
                <div className="absolute lg:top-[125px] top-[20px]  max-w-[1440px] w-full mx-auto left-1/2 -translate-x-1/2 lg:px-[50px] px-[20px]">
                    <h6 className="font-[500] font-kanit lg:text-[70px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">Our Services</h6>
                    <p className="max-w-[582px] w-full font-[300] font-inter lg:text-[20px] text-[14px] lg:leading-[30px] leading-[20px] text-[#FFFFFF]">Smart, Safe, and Field-Tested Solutions — All in One Place.</p>
                </div>
                <h1 className='absolute font-[600] font-kanit lg:text-[180px] text-[60px] lg:leading-[180px] leading-[70px] text-[#FFFFFF4F] right-[0px] lg:bottom-[86px] bottom-[40px]'>Service</h1>
            </div> */}
            <div className='bg-[#FFFFFF]'>
                <div className="max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
                    <div className="new-service-cards">
                        {sList?.map((e, i) => {
                            return (
                                <Link key={i} to={e?.sLink}>
                                    <div className='new-service-card'>
                                        <div className='new-service-card-img bg-white'>

                                            <img src={e?.sImg} />
                                        </div>
                                        <div className='new-service-card-text'>
                                            <div>
                                                <h3 className='ac'> {e?.name}</h3>
                                                <p> {e?.subText}</p>
                                            </div>
                                            <button>Read More</button>



                                        </div>
                                    </div>

                                    {/* <div className='relative rounded-[5px] w-full group'>
                                    <img src={e?.sImg} className='w-full lg:h-[600px] h-[300px] object-cover rounded-[5px]' alt="	Trusted cable management and termination solutions provider in the UAE" />
                                    <div className="absolute inset-0 bg-black/0 transition-opacity duration-300 rounded-[5px]"></div>
                                    <div className='bottom-0 absolute w-full rounded-[5px] bg-[#01386A] px-[20px] py-[22px] opacity-0 group-hover:opacity-100 transition-opacity duration-300 '>
                                        <h6 className="font-[500] font-kanit lg:text-[22px] text-[14px] lg:leading-[33px] leading-[22px] tracking-[0.3px] text-[#FFFFFF] text-center pb-[16px] ">
                                            {e?.name}
                                        </h6>
                                        <p className="font-[300] font-kanit lg:text-[17px] text-[12px] lg:leading-[24px] leading-[18px] text-center text-[#FFFFFF]">
                                            {e?.subText}
                                        </p>
                                    </div>
                                    <h6 className="p-[10px] absolute bottom-[38px] left-[50%] translate-x-[-50%] font-[500] font-kanit lg:text-[22px] text-[14px] lg:leading-[33px] leading-[22px] tracking-[0.3px] text-[#000] text-center w-full opacity-100 group-hover:opacity-0 transition-opacity duration-300">
                                        {e?.name}
                                    </h6>
                                </div> */}

                                </Link>
                            )
                        })}
                    </div>
                </div>
            </div>


        </>
    )
}

export default Service